import forOwn from 'mout/object/forOwn'
import sortByPropText from '../manageSets/sortByPropText';

export default function getAnswers(activeItem) {
  if (activeItem && activeItem.answers) {
    let answers = []
    forOwn(activeItem.answers, (val, key) => {
      const answer = { ...val, key }
      answers.push(answer)
    })
    return sortByPropText(answers, 'key')
  }
}


// WEBPACK FOOTER //
// ./src/helpers/content/manageContent/getAnswers.js